import AccreditationRequired from './AccreditationRequired';

export default AccreditationRequired;
